import { enviroment } from "../../../../../enviroment";
import {
  ListSearchThrottle,
  resolveListSearchThrottle,
} from "../../../../../utils/functions/listSearchThrottle";

// The throttle every TableSearchBar (and the logo list's search-feedback
// hook) runs with - flag REACT_APP_LIST_SEARCH_THROTTLE_ENABLED. Read at
// render time; flag off = 350 ms and no minimum, i.e. today's field.
export function getListSearchThrottle(): ListSearchThrottle {
  return resolveListSearchThrottle(
    enviroment.listSearchThrottleEnabled,
    enviroment.listSearchDebounceMs,
    enviroment.listSearchMinChars,
  );
}
